import { useEffect, useState } from "react";

// Mobile breakpoint. Anything strictly below 768 px is treated as
// mobile. iPad portrait (768 px) lands on the desktop layout, which
// matches the existing desktop-only design language.
export const MOBILE_BREAKPOINT_PX = 768;

const QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX - 0.02}px)`;

function getInitial() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

// Subscribes to the matchMedia query so the boolean flips live when the
// user resizes / rotates the device. SSR-safe (returns false until the
// first client-side effect runs).
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(getInitial);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  return isMobile;
}
